import React from "react"
import { footer, footerSimple } from "../Footer/footer.module.scss"

export default React.memo(() => {
  return (
    <footer className={`${footer} ${footerSimple}`}>
      <address>&copy;2020 MEDLEY, INC.</address>
    </footer>
  )
});
